import { EGameListStatus } from '@gaming1/g1-requests-gaming';

export const gameListErrorMessages = {
  [EGameListStatus.InternalError]: 'core:error.internalServer', // 0
  [EGameListStatus.InvalidRoom]: 'core:error.invalidRoom', // 2
  [EGameListStatus.GameRangeNotFound]:
    'gaming:gameList.message.gameRangeNotFound', // 3
};
